/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} Key used by the search panel (can be cleared by the user) */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {string} Key used exclusively by the PDP section — never cleared by search panel */
  static #SECTION_KEY = 'viewedProductsSection';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 10;

  /**
   * Adds a product to the recently viewed products list.
   * Writes to both the search-panel key and the independent section key.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    // Keep the section key in sync — it is never cleared by clearProducts()
    localStorage.setItem(this.#SECTION_KEY, JSON.stringify(viewedProducts));
  }

  /**
   * Clears recently viewed products from the search-panel storage.
   */
  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products (used by the search panel).
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    } catch (_) {
      return [];
    }
  }

  /**
   * Retrieves the list of recently viewed products for the PDP section.
   * Uses a dedicated key that is never cleared by search-panel actions.
   * @returns {string[]} The list of viewed products.
   */
  static getSectionProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.#SECTION_KEY) || '[]');
    } catch (_) {
      return [];
    }
  }
}
